import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrTag, {
  SR_TAG_THEMES,
} from 'client/components/SrTag/SrTag';

import './SrInfoOptionCheckbox.less';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

const SrInfoOptionCheckbox = ({
  isActive,
  tagTheme,
  title,
  tagContents,
  onClick,
  description,
  collapseUnselected,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <div
      onClick={onClick}
      styleName={classnames(
        'container',
        { isActive },
      )}
    >
      <SrFlex justify='between' align='center'>
        <img
          styleName='checkboxIcon'
          alt='checkbox icon'
          src={isActive ? '/images/checkmark-circle-green.svg' : '/images/circle-small-grey.svg'}
        />
        <SrBox
          marginRight='auto'
          marginLeft='9px'
        >
          <SrText
            color='blueGreycliff'
            font='greycliff'
            fontSize='18px'
            lineHeight='22px'
            letterSpacing='0.56px'
            weight='800'
          >
            {title}
          </SrText>
        </SrBox>
        <SrTag theme={tagTheme}>
          {tagContents}
        </SrTag>
      </SrFlex>
      {(!collapseUnselected || isActive) &&
        <SrBox marginTop='6px' marginBottom='10px' maxWidth={isSmallScreen ? null : 'calc(100% - 160px)'}>
          <SrText
            display='block'
            font='greycliff'
            color='blueGreycliff'
            fontSize='13px'
            lineHeight='18px'
            weight='600'
          >
            {description}
          </SrText>
        </SrBox>
      }
    </div>
  );
};

SrInfoOptionCheckbox.propTypes = {
  isActive: PropTypes.bool,
  tagContents: PropTypes.string.isRequired,
  tagTheme: PropTypes.oneOf(SR_TAG_THEMES).isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  description: PropTypes.string,
  collapseUnselected: PropTypes.bool,
};

SrInfoOptionCheckbox.displayName = 'SrInfoOptionCheckbox';

export default SrInfoOptionCheckbox;
